import { TERMS_EFFECTIVE_DATE, TERMS_SECTIONS } from '../../termsContent';
import ru from './ru';
import kk from './kk';
import de from './de';
import fr from './fr';
import es from './es';
import pt from './pt';
import it from './it';
import zh from './zh';
import ja from './ja';
import ko from './ko';
import hi from './hi';

const en = {
  title: 'Terms of Use',
  description: 'Terms of Use for the Plannely app and website: your account, subscriptions, your content and the rules for using the service.',
  effectiveLabel: 'Effective date:',
  effectiveDate: TERMS_EFFECTIVE_DATE,
  appLabel: 'Application:',
  privacyPhrases: ['Privacy Policy'],
  sections: TERMS_SECTIONS,
};

const translations = { en, ru, kk, de, fr, es, pt, it, zh, ja, ko, hi };

export const TERMS_LANGUAGES = Object.keys(translations);

/** Язык без перевода получает английскую версию; lang нужен браузеру и скринридерам. */
export function getTerms(language) {
  const lang = translations[language] ? language : 'en';
  return { ...translations[lang], lang };
}
